import React from 'react';
// This component is used in components/common/dateselector.jsx
const PeriodButton = (props) => {

    let active = props.active == props.value ? 'active' : '';
    let className = "font--bold main-menu__times__item " + active;
    return (
        <span onClick={() => props.handleClick(props.value)} className={className}>
            {props.value}
        </span>
    );
}
export default PeriodButton


// WEBPACK FOOTER //
// ./src/components/common/dateselector/periodbutton.jsx